const TOKEN = 'TOKEN_POC';

export { TOKEN };
